import { Translate } from 'next-translate';
import { NextRouter } from 'next/router';

import { OpenRfxDrawer } from '@components/providers/RfxDrawerProvider/RfxDrawerProvider';
import { MenuItem } from '@components/layout/SideMenu/types';

import { getDefaultMenuItems } from './getDefaultMenuItems';

interface Params {
  currentPathName: string;
  enableAdoptionReporting?: boolean;
  enableCatalog?: boolean;
  enableNewSettingsPage?: boolean;
  enablePriceUpdate?: boolean;
  enableValueOverviewDashboard?: boolean;
  isAutomated: boolean;
  openRfxDrawer: OpenRfxDrawer;
  router: NextRouter;
  t: Translate;
  unreadCount?: number;
  user: any;
}

export const getSideMenuItems = (params: Params): MenuItem[] => {
  const {
    t,
    user,
    router,
    unreadCount,
    isAutomated,
    enableCatalog,
    enableNewSettingsPage,
    enablePriceUpdate,
    enableValueOverviewDashboard,
    openRfxDrawer,
    currentPathName,
    enableAdoptionReporting,
  } = params;

  const menuItems: MenuItem[] = getDefaultMenuItems(
    t,
    user,
    router,
    unreadCount,
    isAutomated,
    enableValueOverviewDashboard,
    openRfxDrawer,
    currentPathName,
    enableAdoptionReporting,
    enableCatalog,
    enablePriceUpdate,
    enableNewSettingsPage,
  );

  return menuItems;
};
